import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var LazyLoad = require("react-lazyload").default;
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(LazyLoad, {
        children: /*#__PURE__*/ _jsx("img", {
            style: {
                width: props.width,
                height: props.width
            },
            src: "/images/chains/ggg.png",
            alt: "logo"
        })
    });
};
export default Icon;
